import { connect } from 'react-redux'
import { createAuthStateToProps } from 'helpers/auth'
import selectors from 'selectors'
import locationGroupActions from 'actions/locationGroups'
import locationActions from 'actions/locations'
import jobActions from 'actions/jobs'
import assetCategoryActions from 'actions/assetCategories'
import jobReasonActions from 'actions/jobReasons'
import assetActions from 'actions/assets'
import userActions from 'actions/users'
import operatorActions from 'actions/operators'
import operatorGroupActions from 'actions/operatorGroups'
import productCategoryActions from 'actions/productCategories'
import supplierActions from 'actions/suppliers'
import tenantActions from 'actions/tenants'
import customerActions from 'actions/customers'
import Component from 'components/Reports/ItemHistoryReport/Filter'

const mapStateToProps = (state, props) => ({
  ...createAuthStateToProps(state, props),
  locationGroups: selectors.locationGroups.selectOptions(state),
  locations: selectors.locations.selectOptions(state),
  jobs: selectors.jobs.selectOptions(state, { itemsOnly: false }),
  assetCategories: selectors.assetCategories.selectOptions(state),
  jobReasons: selectors.jobReasons.selectOptions(state),
  assets: selectors.assets.selectOptions(state, { itemsOnly: false }),
  users: selectors.users.selectOptions(state),
  operators: selectors.operators.selectOptions(state, { itemsOnly: false }),
  operatorGroups: selectors.operatorGroups.selectOptions(state),
  productCategories: selectors.productCategories.selectOptions(state),
  suppliers: selectors.suppliers.selectOptions(state, { itemsOnly: false }),
  tenants: selectors.tenants.selectOptions(state),
  customers: selectors.customers.selectOptions(state),
})

const mapDispatchToProps = (dispatch, props) => ({
  getLocationGroups: (params) => dispatch(locationGroupActions.getOptions(params)),
  getLocations: (params) =>
    dispatch(
      locationActions.getOptions({
        ...params,
        active: 'All',
        locationVendingTypes: ['NonVending', 'Vending'],
      }),
    ),
  getJobs: (params) =>
    dispatch(
      jobActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getAssetCategories: (params) => dispatch(assetCategoryActions.getOptions(params)),
  getJobReasons: (params) => dispatch(jobReasonActions.getOptions(params)),
  getAssets: (params) =>
    dispatch(
      assetActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
  getUsers: (params) => dispatch(userActions.getOptions({ ...params, active: 'All' })),
  getOperators: (params) =>
    dispatch(
      operatorActions.getOptions({
        active: 'All',
        pageIndex: 1,
        pageSize: 100,
        ...params,
      }),
    ),
  getOperatorGroups: (params) => dispatch(operatorGroupActions.getOptions(params)),
  getProductCategories: (params) =>
    dispatch(productCategoryActions.getOptions({ ...params, active: 'All', pageIndex: 0 })),
  getSuppliers: (params) =>
    dispatch(
      supplierActions.getOptions({
        pageIndex: 1,
        pageSize: 100,
        ...params,
        active: 'All',
      }),
    ),
  getTenants: (params) => dispatch(tenantActions.getOptions(params)),
  getCustomers: (params) => dispatch(customerActions.getOptions(params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
